import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Dropdown,
  Field,
  Input,
  Option,
} from '@fluentui/react-components';

import { Avatar, useUsers } from '@modules/users';

type TProps = {
  open: boolean;
  assigneeId?: string;
  dueDate?: string;
  onAssign: (assignee: string, dueDate?: string, assigneeId?: string) => void;
  onClose: () => void;
};

export const AssignFindingDialog = ({ open, assigneeId, dueDate: initialDueDate, onAssign, onClose }: TProps) => {
  const { users } = useUsers();
  const [assignee, setAssignee] = useState('');
  const [dueDate, setDueDate] = useState('');

  useEffect(() => {
    if (open) {
      setAssignee(assigneeId ?? '');
      setDueDate(initialDueDate ?? '');
    }
  }, [open, assigneeId, initialDueDate]);

  const selectedUser = users?.find((user) => user._id === assignee);

  return (
    <Dialog open={open} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>Assign finding</DialogTitle>
          <DialogContent className="flex flex-col gap-4">
            <Field label="Assignee" required>
              <Dropdown
                value={selectedUser?.name || selectedUser?.mail || ''}
                selectedOptions={assignee ? [assignee] : []}
                placeholder="Select a person"
                onOptionSelect={(_, data) => setAssignee(data.optionValue ?? '')}
              >
                {(users ?? []).map((user) => {
                  const label = user.name || user.mail;
                  return (
                    <Option key={user._id} value={user._id} text={label}>
                      <Avatar user={user} size={24} />
                      {label}
                    </Option>
                  );
                })}
              </Dropdown>
            </Field>

            <Field label="Due date" hint="Optional">
              <Input type="date" value={dueDate} onChange={(_, data) => setDueDate(data.value)} />
            </Field>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button
              appearance="primary"
              disabled={!selectedUser}
              onClick={() =>
                selectedUser && onAssign(selectedUser.name || selectedUser.mail, dueDate || undefined, selectedUser._id)
              }
            >
              Assign
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
